//TREND ANGGOTA
export const GET_LIST_ANGGOTA = "GET_LIST_ANGGOTA";
export const GET_LIST_ANGGOTA_SUCCESS = "GET_LIST_ANGGOTA_SUCCESS";
export const GET_LIST_ANGGOTA_FAIL = "GET_LIST_ANGGOTA_FAIL";